/**
 * Environment variables for the `@saflib/env` package, including inherited variables via `extends`.
 * Generated by `@saflib/env`. To update, make changes to the adjacent `env.schema.json`, navigate to the package root, and run `npm exec saf-env generate`.
 */
export interface EnvEnvSchema {
  /**
   * Comma-separated list of client subdomains, e.g. 'www,app,auth,'. Include an empty string (such as in the example) to indicate there's a client for the root domain.
   */
  CLIENT_SUBDOMAINS: string;
  /**
   * The name of the deployment, e.g. 'production', 'staging', 'development'. This may be used in strings such as database file names and logging metadata; each deployment should have a unique name.
   */
  DEPLOYMENT_NAME: string;
  /**
   * The root domain of the deployment, e.g. 'saf.com'.
   */
  DOMAIN: string;
  /**
   * The environment of the deployment. Generally should avoid using this, consider its use deprecated, prefer instead more specific environment variables.
   */
  NODE_ENV: "development" | "production" | "test";
  /**
   * The protocol of the deployment, e.g. 'https'
   */
  PROTOCOL: "https" | "http";
  /**
   * The timezone of the deployment, e.g. 'America/New_York'. Must be UTC.
   */
  TZ: "UTC";
}

/**
 * `process.env` casted to the `EnvEnvSchema` type.
 */
export const typedEnv = (globalThis.process
  ? process.env
  : {}) as unknown as EnvEnvSchema;
